import { Skeleton, Stack, Typography, useTheme } from '@mui/material'

import { ECampaignKeys } from '~/features/campaigns/models'
import useGetSelectedCampaign from '~/hooks/useGetSelectedCampaign'
import rem from '~/utils/ui'

export default function OfuManageTitle() {
  const theme = useTheme()
  const { campaign, isLoading } = useGetSelectedCampaign()

  const campaignName = campaign?.[ECampaignKeys.campaignName]
  const description = campaign?.[ECampaignKeys.description]

  return (
    <Stack sx={{ maxWidth: '100%', minWidth: 0, overflow: 'hidden' }}>
      {isLoading && (
        <Skeleton variant="text" width={rem(400)} height={rem(28)} />
      )}

      {!isLoading && (
        <>
          <Typography
            variant="h4"
            fontSize={rem(20)}
            fontWeight={700}
            noWrap
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {campaignName}
          </Typography>

          <Typography
            variant="body2"
            fontSize={rem(12)}
            fontWeight={400}
            color={theme.palette.text.secondary}
            noWrap
            overflow="hidden"
            textOverflow="ellipsis"
          >
            {description}
          </Typography>
        </>
      )}
    </Stack>
  )
}
